import { useEffect, useState } from "react";
// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import axios from "axios.js";

import { useAuthUser } from "react-auth-kit";
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Grid,
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import usePageTitle from "app/pageTitle";

function UserProfile() {
  const title = "My Profile";
  usePageTitle(title);

  const auth = useAuthUser();
  const accountInfo = auth();

  const [refreshPage, setRefreshPage] = useState(false);
  // const [profile, setProfile] = useState(null);
  const [aleroWallet, setAleroWallet] = useState(null);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/profile.json`)
        .then((result) => {
          setShowLoading(false);
          // console.log(result);
          if (result.data.status === "success") {
            // setProfile(result.data.data.profile);
            setAleroWallet(result.data.data.profile.wallet.alero);
          } else {
            setErrMsg(result.data.data.message);
            setSeverity("error");
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setSeverity("error");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  const [aleroID, setAleroID] = useState(null);

  async function linkAlero() {
    if (aleroID === null) {
      setSeverity("error");
      setErrMsg("Alero ID is required");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      alero_account: aleroID,
    };

    await axios
      .post("agents/alero/link.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox pt={1.5} pb={3} mb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {accountInfo === null ? (
              <> </>
            ) : (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox mt={1}>
                      <MDBox p={2}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Account Information
                        </MDTypography>
                      </MDBox>
                      <TableContainer component={Paper}>
                        <Table aria-label="personal information">
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Last Name
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.last_name}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Other Names
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.first_name}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {/* <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Gender
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.gender}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Date Of Birth
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.dob}
                                </MDTypography>
                              </TableCell>
                            </TableRow> */}
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Email Address
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.email_address}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontWeight="medium">
                                  Phone Number
                                </MDTypography>
                              </TableCell>
                              <TableCell align="right">
                                <MDTypography variant="h6" fontWeight="light">
                                  {accountInfo.phone_number}
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox mt={1}>
                      <MDBox p={2}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Alero Wallet
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          {aleroWallet
                            ? "Your Alero Account has been linked."
                            : "Link your Alero account to receive your commissions."}
                        </MDTypography>
                      </MDBox>
                      {aleroWallet ? (
                        <MDBox>
                          <TableContainer component={Paper}>
                            <Table aria-label="personal information">
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="medium">
                                      Alero ID
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {aleroWallet.account_number}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell>
                                    <MDTypography variant="h6" fontWeight="medium">
                                      Account Name
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {aleroWallet.account_name}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </MDBox>
                      ) : (
                        <MDBox p={2}>
                          <MDBox mt={2}>
                            <MDInput
                              placeholder="Alero ID, Email, Hashtag"
                              name="alero_id"
                              margin="dense"
                              label="Alero ID"
                              type="text"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setAleroID(e.target.value)}
                            />
                          </MDBox>
                          <MDBox mt={3}>
                            <MDButton
                              color="info"
                              variant="contained"
                              sx={{ width: "100%" }}
                              onClick={() => {
                                linkAlero();
                              }}
                            >
                              Link Account
                            </MDButton>
                          </MDBox>
                          <MDBox mt={2} textAlign="center">
                            <MDTypography variant="caption" fontWeight="light">
                              <a
                                href={`https://app.alero.africa/sign-up?extRef=SHMX&id=${accountInfo.reference}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                Don&apos;t have an Alero Account? Get one here.
                              </a>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      )}
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserProfile;
